import React, { Component } from "react";
import { connect } from "dva";
import Container from "@/components/Container";
import Iframe from "@/components/Iframe";
import { NEW_RDP_PUBLIC_URL } from "@/utils/utils";

@connect(({ user }) => ({
  ...user
}))
class Standard extends Component {
  render() {
    const { currentUser } = this.props;
    const { orgId, enOrgType } = currentUser;

    if (!orgId) {
      return null;
    }

    const IframeDom = Iframe({
      src: `${NEW_RDP_PUBLIC_URL}/${enOrgType === 'general_school' ? '1aa07a88209272a2004cbd977948a451' : '6e98df956117748fcae9d59c60b70514'}?orgId=${orgId}`
    });

    return (
      <Container breStates>
        <IframeDom />
      </Container>
    );
  }
}

export default Standard;